import { jsx, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, useMemo } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toViewClass } from "../../utils/toViewClass.js";
import { toStateClass } from "../../utils/toStateClass.js";
import { toEnumClass } from "../../utils/toEnumClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const Stack = memo(
  forwardRef(
    ({
      align,
      basis,
      evenly,
      children,
      className,
      direction,
      gap,
      grow,
      justify,
      shrink,
      style: styleProp,
      wrap,
      ...rest
    }, ref) => {
      const prefix = useClassNamePrefix();
      const style = useMemo(() => ({
        ...{ flexBasis: basis },
        ...typeof grow !== "boolean" ? { flexGrow: grow } : {},
        ...typeof shrink !== "boolean" ? { flexShrink: shrink } : {},
        ...styleProp
      }), [basis, grow, shrink, styleProp]);
      return /* @__PURE__ */ jsx(Fragment, { children: children && /* @__PURE__ */ jsx(
        "div",
        {
          ...rest,
          className: classNames(
            `${prefix}stack`,
            toViewClass(`${direction}`, true),
            toStateClass("evenly-distributed", evenly),
            toEnumClass("gap-", gap),
            align && toEnumViewClass(`align-${align}`),
            grow === true && toEnumViewClass("grow"),
            justify && toEnumViewClass(`justify-${justify}`),
            shrink === true && toEnumViewClass("shrink"),
            wrap && toEnumViewClass(wrap === true ? `wrap` : `wrap-${wrap}`),
            className
          ),
          style,
          ref,
          children
        }
      ) });
    }
  )
);
Stack.displayName = "Stack";
export {
  Stack
};
//# sourceMappingURL=Stack.js.map
